module.exports = __webpack_public_path__ + "img/symbol_s02.3adb1b8.svg";